import {useState} from "react";
import {useDispatch} from "react-redux";
import {IResponse} from "../core/interfaces/common";
import {addToast} from "../store/slices/uiSlice";
import {toastError} from "../core/helpers/toastHelper";

type UpdatableOptions<T> = {
    getErrorToast?: (status: number, data: T) => { title: string, message: string },
    skipErrorToast?: (status: number, data: T) => boolean,

}
const useUpdatableObject = <T, C>(object: T, submitFunction: (object: T) => Promise<IResponse<C>>, options?: UpdatableOptions<C>) => {
    const [updated, setUpdated] = useState<T>(object);
    const [obj] = useState<T>(object);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch()
    const isEdited = () => {
        return JSON.stringify(updated) !== JSON.stringify(obj);
    }

    const submit = async (): Promise<C> => {
        return new Promise<C>((resolve, reject) => {
            if (loading) {
                dispatch(addToast(toastError("Ett fel uppstod", "Programmet väntar på svar, var vänligen vänta.")));
                reject();
            }
            setLoading(true)
            submitFunction(updated).then(resp => {
                if (resp.status >= 400) {
                    let toastInfo = {
                        title: "Ett fel uppstod",
                        message: "Ett oväntat fel uppstod. Försök igen eller kontakta support."
                    }
                    if (options && options.getErrorToast) {
                        toastInfo = options.getErrorToast(resp.status, resp.data);
                    }
                    const skip = options && options.skipErrorToast && options.skipErrorToast(resp.status, resp.data);
                    if (!skip) {
                        dispatch(addToast(toastError(toastInfo.title, toastInfo.message)));
                    }
                    reject(resp.data);
                } else {
                    resolve(resp.data);
                }
            }).finally(() => setLoading(false))
        })
    }

    return [updated, setUpdated, isEdited, submit, loading] as const;
}

export default useUpdatableObject